import { Component, ElementRef, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

@Component({
    selector: 'root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    standalone: true,
    imports: [
        RouterOutlet
    ]
})
export class AppComponent implements OnInit {


  constructor(iconLibrary: FaIconLibrary, private elRef: ElementRef) {
        iconLibrary.addIconPacks(fas, far, fab);
    }

  ngOnInit() {
    this.elRef.nativeElement.removeAttribute("ng-version");
  }

  title = 'Liquid Nicotine Vape Directory';
}
